module.exports = __webpack_public_path__ + "static/media/img_familia.870afe53.jpg";